module.exports = __webpack_public_path__ + "static/img/BK10.e6d7e14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/BK10.png
// module id = IGbx
// module chunks = 9